export const DATE_DISPLAY_FORMAT = "MM-DD-YYYY";

const pad = (value) => String(value).padStart(2, "0");

const toIsoFromParts = (year, month, day) => {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);

  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) {
    return null;
  }

  if (m < 1 || m > 12 || d < 1 || d > 31) {
    return null;
  }

  return `${String(y).padStart(4, "0")}-${pad(m)}-${pad(d)}`;
};

export const toIsoDate = (value) => {
  if (!value) return null;

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;

    const iso = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) {
      return toIsoFromParts(iso[1], iso[2], iso[3]);
    }

    const monthDayOrDayMonth = trimmed.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    if (monthDayOrDayMonth) {
      const first = Number(monthDayOrDayMonth[1]);
      const second = Number(monthDayOrDayMonth[2]);
      const year = monthDayOrDayMonth[3];

      // Default to MM-DD-YYYY to preserve existing behavior.
      // If first part cannot be a valid month but second can, treat as DD-MM-YYYY.
      const asMonthDay = toIsoFromParts(year, monthDayOrDayMonth[1], monthDayOrDayMonth[2]);
      if (asMonthDay) {
        return asMonthDay;
      }

      if (first > 12 && second >= 1 && second <= 12) {
        return toIsoFromParts(year, monthDayOrDayMonth[2], monthDayOrDayMonth[1]);
      }
    }

    const parsed = new Date(trimmed);
    if (!Number.isNaN(parsed.getTime())) {
      return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`;
    }

    return null;
  }

  if (typeof value === "object" && value !== null) {
    if ("$date" in value) {
      return toIsoDate((value).$date);
    }

    if ("format" in value && typeof (value).format === "function") {
      const formatted = (value).format("YYYY-MM-DD");
      return toIsoDate(formatted);
    }

    if ("toDate" in value && typeof (value).toDate === "function") {
      const asDate = (value) .toDate();
      if (!Number.isNaN(asDate.getTime())) {
        return `${asDate.getFullYear()}-${pad(asDate.getMonth() + 1)}-${pad(asDate.getDate())}`;
      }
    }
  }

  return null;
};

export const toMmDdYyyy = (value, fallback = "") => {
  const iso = toIsoDate(value);
  if (!iso) return fallback;

  const [year, month, day] = iso.split("-");
  if (!year || !month || !day) return fallback;
  return `${month}-${day}-${year}`;
};

export const toApiDateMmDdYyyy = (value) => toMmDdYyyy(value, "");
